<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Valutazione" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data</label>
                        <date-picker v-if="!isReadOnly" format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.data" type="date"></date-picker>
                        <span v-else>{{ formatDate(jsonData.data) }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Infermiere, case manager</label>
                        <span v-if="isReadOnly">{{ jsonData.infermiereCaseManager }}</span>
                        <b-form-input v-else v-model="jsonData.infermiereCaseManager"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Care giver</label>
                        <span v-if="isReadOnly">{{ jsonData.careGiver }}</span>
                        <b-form-input v-else v-model="jsonData.careGiver"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Telefono</label>
                        <span v-if="isReadOnly">{{ jsonData.careGiverTelefono }}</span>
                        <b-form-input v-else v-model="jsonData.careGiverTelefono"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Medico di famiglia</label>
                        <span v-if="isReadOnly">{{ jsonData.medicoFamiglia }}</span>
                        <b-form-input v-else v-model="jsonData.medicoFamiglia"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome</label>
                        <span v-if="isReadOnly">{{ nominativo }}</span>
                        <b-form-input v-else v-model="nominativo" :disabled="true"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Sesso</label>
                        <span v-if="isReadOnly">{{ jsonDataAccettazione.accettazioneAnagrafica.sesso }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataAccettazione.accettazioneAnagrafica.sesso" class="mb-2 mr-sm-2 mb-sm-0" :options="sessooptions" value-field="value" text-field="text" :disabled="true"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Età</label>
                        <span v-if="isReadOnly">{{ eta }}</span>
                        <b-form-input v-else v-model="eta" :disabled="true"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Caregiver Presente/Assente</label>
                        <span v-if="isReadOnly">{{ jsonData.careGiverPresenza }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.careGiverPresenza" class="mb-2 mr-sm-2 mb-sm-0" :options="presenteAssenteOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Chi è</label>
                        <span v-if="isReadOnly">{{ jsonData.careGiverRelazione }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.careGiverRelazione" class="mb-2 mr-sm-2 mb-sm-0" :options="relazioneOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Altro</label>
                        <span v-if="isReadOnly">{{ jsonData.careGiverRelazioneAltro }}</span>
                        <b-form-input v-else id="inline-form-custom-select-pref" v-model="jsonData.careGiverRelazioneAltro" :disabled="jsonData.careGiverRelazione !== 'ALTRO'"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Rapporto con caregiver</label>
                        <span v-if="isReadOnly">{{ jsonData.rapportoCareGiver }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.rapportoCareGiver" class="mb-2 mr-sm-2 mb-sm-0" :options="rapportoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Altro</label>
                        <span v-if="isReadOnly">{{ jsonData.rapportoCareGiverAltro }}</span>
                        <b-form-input v-else v-model="jsonData.rapportoCareGiverAltro" :disabled="jsonData.rapportoCareGiver !== 'ALTRO'"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Rapporto con congiunti</label>
                        <span v-if="isReadOnly">{{ jsonData.rapportoCongiunti }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.rapportoCongiunti" class="mb-2 mr-sm-2 mb-sm-0" :options="rapportoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Altro</label>
                        <span v-if="isReadOnly">{{ jsonData.rapportoCareGiverAltro }}</span>
                        <b-form-input v-else v-model="jsonData.rapportoCongiuntiAltro" :disabled="jsonData.rapportoCongiunti !== 'ALTRO'"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Diagnosi principale</label>
                        <span v-if="isReadOnly">{{ jsonData.diagnosiPrincipale }}</span>
                        <b-form-textarea v-else v-model="jsonData.diagnosiPrincipale" rows="3" max-rows="6"></b-form-textarea>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                        <b-card class="sa-card sa-card-border" header="Comorbidità fisiche" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Diabete melito</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheDiabeteMelito }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheDiabeteMelito" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Ipertensione arteriosa</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheIpertensioneArteriosa }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheIpertensioneArteriosa" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Scompenso cardiaco</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheCompensoCardiaco }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheCompensoCardiaco" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Fibrillazione atriale</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheFibrillazioneAtriale }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheFibrillazioneAtriale" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Ictus emorragico</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheIctusEmorragico }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheIctusEmorragico" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Ictus ischemico</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheIctusIschemico }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheIctusIschemico" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">BPCO</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheBpco }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheBpco" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Trombosi ven. profonda</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheTrombosiProfonda }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheTrombosiProfonda" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Embolia polmonare</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheEmboliaPolmonare }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheEmboliaPolmonare" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Sindrome cavale</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheSindromeCavale }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheSindromeCavale" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Pancreatite</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisichePancreatite }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisichePancreatite" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Dipendenza da alcool</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheDipendenzaAlcool }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheDipendenzaAlcool" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Dipendenza da fumo</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheDipendenzaFumo }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheDipendenzaFumo" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Dipendenza da altro</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheDipendenzaAltro }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaFisicheDipendenzaAltro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Dettaglio</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaFisicheDipendenzaAltroDettaglio }}</span>
                                    <b-form-input v-else v-model="jsonData.comorbiditaFisicheDipendenzaAltroDettaglio" :disabled="jsonData.comorbiditaFisicheDipendenzaAltro !== 'SI'"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-card class="sa-card sa-card-border" header="Comorbidità psichiche" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Parkinson</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheParkinson }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheParkinson" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Demenza</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheDemenza }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheDemenza" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Sindrome bipolare</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheSindromeBipolare }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheSindromeBipolare" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Psicosi, delirium</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichichePsicosi }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichichePsicosi" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Alzheimer</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheAlzheimer }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheAlzheimer" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Schizofrenia</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheSchizofrenia }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheSchizofrenia" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Droghe di abuso/psicofarmaci</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheDroghePsicofarmaci }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheDroghePsicofarmaci" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Dettaglio</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheDroghePsicofarmaciDettaglio }}</span>
                                    <b-form-input v-else v-model="jsonData.comorbiditaPsichicheDroghePsicofarmaciDettaglio" :disabled="jsonData.comorbiditaPsichicheDroghePsicofarmaci !== 'SI'"></b-form-input>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Altro</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheAltro }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.comorbiditaPsichicheAltro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <label class="sa-label-data">Dettaglio</label>
                                    <span v-if="isReadOnly">{{ jsonData.comorbiditaPsichicheAltroDettaglio }}</span>
                                    <b-form-input v-else v-model="jsonData.comorbiditaPsichicheAltroDettaglio" :disabled="jsonData.comorbiditaPsichicheAltro !== 'SI'"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Condizione clinica generale alla presa in carico</label>
                        <span v-if="isReadOnly">{{ jsonData.condizioneClinica }}</span>
                        <b-form-textarea v-else v-model="jsonData.condizioneClinica" rows="3" max-rows="6"></b-form-textarea>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Medicazione avanzate</label>
                        <span v-if="isReadOnly">{{ jsonData.medicazioneAvanzate }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.medicazioneAvanzate" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Alimentazione</label>
                        <span v-if="isReadOnly">{{ jsonData.alimentazione }}</span>
                        <b-form-input v-else v-model="jsonData.alimentazione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Idratazione</label>
                        <span v-if="isReadOnly">{{ jsonData.idratazione }}</span>
                        <b-form-input v-else v-model="jsonData.idratazione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Attività intestinale</label>
                        <span v-if="isReadOnly">{{ jsonData.attivitaIntestinale }}</span>
                        <b-form-input v-else v-model="jsonData.attivitaIntestinale"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Mucosa orale</label>
                        <span v-if="isReadOnly">{{ jsonData.mucosaOrale }}</span>
                        <b-form-input v-else v-model="jsonData.mucosaOrale"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Qualita del riposo</label>
                        <span v-if="isReadOnly">{{ jsonData.qualitaRiposo }}</span>
                        <b-form-input v-else v-model="jsonData.qualitaRiposo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-card class="sa-card sa-card-border" header="Presenza di ldp LDP" header-tag="header" footer-tag="footer" title="">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaLdp" :fields="fields" :current-page="1" :per-page="50" sort-icon-left head-variant="light" class="sa-b-table">
                                <template #cell(index)="item">
                                    {{ item.index + 1 }}
                                </template>
                                <template #cell(localizzazione)="item">
                                    <b-form-input v-if="item.index === jsonData.listaLdp.length - 1 && !isReadOnly" v-model="item.item.localizzazione"></b-form-input>
                                    <span v-else> {{ item.item.localizzazione }} </span>
                                </template>
                                <template #cell(stadio)="item">
                                    <b-form-input v-if="item.index === jsonData.listaLdp.length - 1 && !isReadOnly" v-model="item.item.stadio"></b-form-input>
                                    <span v-else> {{ item.item.stadio }} </span>
                                </template>
                                <template #cell(actions)="row">
                                    <b-button v-if="row.index === jsonData.listaLdp.length - 1 && !isReadOnly" size="sm" v-b-tooltip.hover title="Aggiungi" variant="outline-success" @click="onAddLdp(jsonData.listaLdp, row.item)">
                                        <font-awesome-icon icon="plus"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-if="row.index !== jsonData.listaLdp.length - 1 && !isReadOnly" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelteLdp(jsonData.listaLdp, row)">
                                        <b-icon icon="trash"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-card>
                        <b-card class="sa-card sa-card-border" header="Presenza di Presidi" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Materassino anti ldp</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiMaterassinoAntiLdp }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiMaterassinoAntiLdp" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Pannolone</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiPannolone }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiPannolone" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Catetere vescicale</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiCatetereVescicale }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiCatetereVescicale" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Data ultimo cambio</label>
                                    <span v-if="isReadOnly">{{ formatDate(jsonData.presidiCatetereVescicaleDataCambio) }}</span>
                                    <date-picker v-else format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.presidiCatetereVescicaleDataCambio" type="date" :disabled="jsonData.presidiCatetereVescicale !== 'SI'"></date-picker>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Accesso venoso periferico</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiAccessoVenoso }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiAccessoVenoso" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">CVC</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiCvc }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiCvc" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">PICC</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiPicc }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiPicc" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Colostomia</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiColostomia }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiColostomia" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Urostomie</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiUrostomie }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiUrostomie" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Nefrostomie</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiNefrostomie }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiNefrostomie" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">SNG</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiSng }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiSng" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">PEG</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiPeg }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiPeg" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Tracheotomia</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiTracheotomia }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiTracheotomia" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Ossigeno</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiOssigeno }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiOssigeno" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Altro</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiAltro }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.presidiAltro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Dettaglio</label>
                                    <span v-if="isReadOnly">{{ jsonData.presidiAltroDettaglio }}</span>
                                    <b-form-input v-else v-model="jsonData.presidiAltroDettaglio" :disabled="jsonData.presidiAltro !== 'SI'"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card class="sa-card sa-card-border" header="Utilizzo abituale di ausili" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Sollevatore</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliSollevatore }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliSollevatore" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Comoda</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliComoda }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliComoda" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Sedia a rotelle</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliSediaRotelle }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliSediaRotelle" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Canedesi</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliCanadesi }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliCanadesi" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Bastone da paseggio</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliBastonePaseggio }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliBastonePaseggio" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Deambulatore</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliDeambulatore }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliDeambulatore" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>

                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Altro</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliAltro }}</span>
                                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.ausiliAltro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Dettaglio</label>
                                    <span v-if="isReadOnly">{{ jsonData.ausiliAltroDettaglio }}</span>
                                    <b-form-input v-else v-model="jsonData.ausiliAltroDettaglio" :disabled="jsonData.ausiliAltro !== 'SI'"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card class="sa-card sa-card-border" header="Diagnosi infermieristiche" header-tag="header" footer-tag="footer" title="">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <span v-if="isReadOnly">{{ jsonData.diagnosiInfermieristiche }}</span>
                                    <b-form-textarea v-else v-model="jsonData.diagnosiInfermieristiche" rows="3" max-rows="6"></b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";

export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            pathResource: "/rsapazientecartellainfermieristica",
            pathResourceCheck: "/rsapazientecartellainfermieristica/check",
            pathResourceAccettazione: "/accettazioni",
            jsonData: {
                data: null,
                infermiereCaseManager: "",
                careGiver: "",
                careGiverTelefono: "",
                medicoFamiglia: "",
                careGiverPresenza: null,
                careGiverRelazione: null,
                careGiverRelazioneAltro: null,
                rapportoCareGiver: null,
                rapportoCareGiverAltro: null,
                rapportoCongiunti: null,
                diagnosiPrincipale: null,
                comorbiditaFisicheDiabeteMelito: null,
                comorbiditaFisicheIpertensioneArteriosa: null,
                comorbiditaFisicheCompensoCardiaco: null,
                comorbiditaFisicheFibrillazioneAtriale: null,
                comorbiditaFisicheIctusEmorragico: null,
                comorbiditaFisicheIctusIschemico: null,
                comorbiditaFisicheBpco: null,
                comorbiditaFisicheTrombosiProfonda: null,
                comorbiditaFisicheEmboliaPolmonare: null,
                comorbiditaFisicheSindromeCavale: null,
                comorbiditaFisichePancreatite: null,
                comorbiditaFisicheDipendenzaAlcool: null,
                comorbiditaFisicheDipendenzaFumo: null,
                comorbiditaFisicheDipendenzaAltro: null,
                comorbiditaFisicheDipendenzaAltroDettaglio: "",
                comorbiditaPsichicheParkinson: null,
                comorbiditaPsichicheDemenza: null,
                comorbiditaPsichicheSindromeBipolare: null,
                comorbiditaPsichichePsicosi: null,
                comorbiditaPsichicheAlzheimer: null,
                comorbiditaPsichicheSchizofrenia: null,
                comorbiditaPsichicheDroghePsicofarmaci: null,
                comorbiditaPsichicheDroghePsicofarmaciDettaglio: "",
                comorbiditaPsichicheAltro: null,
                comorbiditaPsichicheAltroDettaglio: null,
                condizioneClinica: null,
                medicazioneAvanzate: null,
                alimentazione: null,
                idratazione: null,
                attivitaIntestinale: null,
                mucosaOrale: null,
                qualitaRiposo: null,
                listaLdp: [{ localizzazione: "", stadio: "" }],
                presidiMaterassinoAntiLdp: null,
                presidiPannolone: null,
                presidiCatetereVescicale: null,
                presidiCatetereVescicaleDataCambio: null,
                presidiAccessoVenoso: null,
                presidiCvc: null,
                presidiPicc: null,
                presidiColostomia: null,
                presidiUrostomie: null,
                presidiNefrostomie: null,
                presidiSng: null,
                presidiPeg: null,
                presidiTracheotomia: null,
                presidiOssigeno: null,
                presidiAltro: null,
                presidiAltroDettaglio: "",
                ausiliSollevatore: null,
                ausiliComoda: null,
                ausiliSediaRotelle: null,
                ausiliCanadesi: null,
                ausiliBastonePaseggio: null,
                ausiliDeambulatore: null,
                ausiliAltro: null,
                ausiliAltroDettaglio: "",
                diagnosiInfermieristiche: "",
            },
            jsonDataAccettazione: { accettazioneAnagrafica: {} },
            nominativo: "",
            eta: null,
            sessooptions: [
                { text: "- Seleziona Sesso -", value: null },
                { text: "Maschio", value: "M" },
                { text: "Femmina", value: "F" },
            ],
            presenteAssenteOptions: [
                { text: "- Seleziona Valore -", value: null },
                { text: "PRESENTE", value: "PRESENTE" },
                { text: "ASSENTE", value: "ASSENTE" },
            ],
            relazioneOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "CONIUGE", value: "CONIUGE" },
                { text: "COMPAGNO/A", value: "COMPAGNO/A" },
                { text: "BADANTE", value: "BADANTE" },
                { text: "FIGLI", value: "FIGLI" },
                { text: "PARENTE DI II O TERZO GRADO", value: "PARENTE DI II O TERZO GRADO" },
                { text: "AMICO/A", value: "AMICO/A" },
                { text: "ASSOCIAZIONE DI VOLONTARIATO", value: "ASSOCIAZIONE DI VOLONTARIATO" },
                { text: "ALTRO", value: "ALTRO" },
            ],
            rapportoOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "BUONO", value: "BUONO" },
                { text: "CONFLITTUALE", value: "CONFLITTUALE" },
                { text: "INDIFFERENTE", value: "INDIFFERENTE" },
                { text: "ALTRO", value: "ALTRO" },
            ],
            sinoOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Localizzazione",
                    key: "localizzazione",

                    //thStyle: "width: 7rem",
                },
                {
                    label: "Stadio",
                    key: "stadio",

                    //thStyle: "width: 7rem",
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },

    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        if (me.idRisorsa !== null) {
            me.loadData();
        }
        me.jsonData = {
            data: new Date().getTime(),
            infermiereCaseManager: "",
            careGiver: "",
            careGiverTelefono: "",
            medicoFamiglia: "",
            idAccettazione: me.idAccettazione,
            careGiverPresenza: null,
            careGiverRelazione: null,
            careGiverRelazioneAltro: null,
            rapportoCareGiver: null,
            rapportoCareGiverAltro: null,
            rapportoCongiunti: null,
            diagnosiPrincipale: null,
            comorbiditaFisicheDiabeteMelito: null,
            comorbiditaFisicheIpertensioneArteriosa: null,
            comorbiditaFisicheCompensoCardiaco: null,
            comorbiditaFisicheFibrillazioneAtriale: null,
            comorbiditaFisicheIctusEmorragico: null,
            comorbiditaFisicheIctusIschemico: null,
            comorbiditaFisicheBpco: null,
            comorbiditaFisicheTrombosiProfonda: null,
            comorbiditaFisicheEmboliaPolmonare: null,
            comorbiditaFisicheSindromeCavale: null,
            comorbiditaFisichePancreatite: null,
            comorbiditaFisicheDipendenzaAlcool: null,
            comorbiditaFisicheDipendenzaFumo: null,
            comorbiditaFisicheDipendenzaAltro: null,
            comorbiditaFisicheDipendenzaAltroDettaglio: "",
            comorbiditaPsichicheParkinson: null,
            comorbiditaPsichicheDemenza: null,
            comorbiditaPsichicheSindromeBipolare: null,
            comorbiditaPsichichePsicosi: null,
            comorbiditaPsichicheAlzheimer: null,
            comorbiditaPsichicheSchizofrenia: null,
            comorbiditaPsichicheDroghePsicofarmaci: null,
            comorbiditaPsichicheDroghePsicofarmaciDettaglio: "",
            comorbiditaPsichicheAltro: null,
            comorbiditaPsichicheAltroDettaglio: null,
            condizioneClinica: null,
            medicazioneAvanzate: null,
            alimentazione: null,
            idratazione: null,
            attivitaIntestinale: null,
            mucosaOrale: null,
            qualitaRiposo: null,
            listaLdp: [{ localizzazione: "", stadio: "" }],
            presidiMaterassinoAntiLdp: null,
            presidiPannolone: null,
            presidiCatetereVescicale: null,
            presidiCatetereVescicaleDataCambio: null,
            presidiAccessoVenoso: null,
            presidiCvc: null,
            presidiPicc: null,
            presidiColostomia: null,
            presidiUrostomie: null,
            presidiNefrostomie: null,
            presidiSng: null,
            presidiPeg: null,
            presidiTracheotomia: null,
            presidiOssigeno: null,
            presidiAltro: null,
            presidiAltroDettaglio: "",
            ausiliSollevatore: null,
            ausiliComoda: null,
            ausiliSediaRotelle: null,
            ausiliCanadesi: null,
            ausiliBastonePaseggio: null,
            ausiliDeambulatore: null,
            ausiliAltro: null,
            ausiliAltroDettaglio: "",
            diagnosiInfermieristiche: "",
        };
        me.loadDataAccettazione();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.idRisorsa, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onAddLdp(array, item) {
            let me = this;
            me.addLdp(array, item);
        },
        addLdp(array, value) {
            console.log(value);

            if (value.stadio !== "" && value.localizzazione !== "") {
                array.push({ localizzazione: "", stadio: "" });
            } else {
                this.$bvModal
                    .msgBoxOk("Inserire tutti i campi ", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then((value) => {
                        console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelteLdp(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        loadDataAccettazione() {
            let me = this;
            me.loadDataResources(me.pathResourceAccettazione + "/" + me.idAccettazione, {}, me.resultResponseAccettazione, me.resultErrorAccettazione);
        },
        resultResponseAccettazione(response) {
            let me = this;
            me.jsonDataAccettazione = response.data.data;
            me.nominativo = me.jsonDataAccettazione.accettazioneAnagrafica.cognome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.nome;
            me.eta = me.calcoloEta(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
        },
        resultErrorAccettazione(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore durante il caricamento dell'Accettazione" + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
